import { muiStyles } from 'utils/design';

export const useStyles = muiStyles<{ indent: number }>((theme, { indent }) => ({
  indent: {
    marginLeft: theme.spacing(indent * 4),
  },
}));
